import React, { useContext, useEffect, useState } from 'react'
import { firestore } from '../../../firebase'
import { dateFormatterShort } from '../../../helpers/dateFormatter';
import { totalIncomeCalculator } from '../../../helpers/financeCalculator';
import { numberFormatter } from '../../../helpers/numberFormatter';
import StateContext from '../../../StateContext'

function UserBudgetIncomes({setTotalIncome, month, year}) {

    const appState = useContext(StateContext)

    const [incomes, setIncomes] = useState([]);
    const [filteredIncomes, setFilteredIncomes] = useState([])
    const [show, setShow] = useState(true)

    useEffect(() => {
        if (appState.userId) {
            try {
                const budgetIncomeRef = firestore.collection("users").doc(appState.userId).collection("budget");

                if (month) {
                    budgetIncomeRef.where("type", "==", "income").where("month", "==", month.number).onSnapshot(({docs}) => {
                        const incomes = docs.map(doc => {
                            return {id: doc.id, ...doc.data()}
                        })
                        setIncomes(incomes);
                        setFilteredIncomes(incomes)
                        if (incomes.length > 0) {
                            const totalIncome = totalIncomeCalculator(incomes);
                            if (totalIncome) {
                                setTotalIncome(totalIncome);
                            } else {
                                setTotalIncome(0)
                            }
                        }                  
                    })
                } else {
                    budgetIncomeRef.where("type", "==", "income").onSnapshot(({docs}) => {
                        const incomes = docs.map(doc => {
                            return {id: doc.id, ...doc.data()}
                        })
                        setIncomes(incomes);
                        setFilteredIncomes(incomes)
                        const totalIncome = totalIncomeCalculator(incomes);
                        setTotalIncome(totalIncome);
                    })
                }


            } catch (error) {
                
            }
        }


    }, [appState.userId, month])

    useEffect(() => {
        console.log(incomes, month, year)
        if (incomes) {
            if (month && year) {
                const newIncomes = filterBudgetByMonthAndYear(month.number, year, incomes)
                setFilteredIncomes(newIncomes)
                if (newIncomes.length > 0) {
                    console.log(newIncomes)
                    const totalIncome = totalIncomeCalculator(newIncomes);
                    if (totalIncome) {
                        setTotalIncome(totalIncome);
                    } else {
                        setTotalIncome(0)
                    }
                }   
            }
            console.log(incomes)

        }
    }, [month, year, incomes])

    function filterBudgetByMonthAndYear(month, year, budget) {
        const filtered = budget?.filter((item) => {
            return item.month === month && item.year === year
        })
        console.log(filtered)
        return filtered
    }

    async function deleteHandler(e, id) {
        e.preventDefault();
        try {
            const budgetIncomeRef = firestore.collection("users").doc(appState.userId).collection("budget").doc(id);
            budgetIncomeRef.delete();
        } catch (error) {
            
        }

    }

    function toggle() {
        if (show) {
            setShow(false);
        } else {
            setShow(true);
        }
    }

    return (
        <div>
            <div onClick={toggle} className="card card-header bg-lightgrey">
                <div>
                    Inntekter <span className="float-right"><i className={show ? "fa fa-chevron-down" : "fa fa-chevron-up"}></i> </span> 
                </div>
            </div>
            <br />
            {show && (
                <div className="card card-body">
                    {filteredIncomes?.map((income, index) => {
                        return (
                            <div key={index}>
                                <span className="font-weight-bold">{dateFormatterShort(income.date)} </span>
                                <span>{income.description}</span>
                                <span className="float-right text-success">{numberFormatter(income.sum)} <i onClick={(e) => deleteHandler(e, income.id)} className="fas fa-trash text-danger"></i></span>
                                <hr />
                            </div>
                        )
                    })}
                    <div>
                        <span className="font-weight-bold">Totale inntekter </span>
                        
                        <span className="float-right text-success font-weight-bold">{totalIncomeCalculator(filteredIncomes)} </span>
                        <hr />
                    </div>
                </div>
            )}
            {!show && (
                <div>
                    <span className="font-weight-bold">Totale inntekter </span>
                    
                    <span className="float-right text-success font-weight-bold">{totalIncomeCalculator(filteredIncomes)} </span>
                    <hr />
                </div>
            )}
        </div>
    )
}
export default UserBudgetIncomes